export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7835.23711a97.jpg";